
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Travelsagentsinpuneforfullbushire() {



    const cardData =
    {
        keyword: 'Travel Agents in Pune for Full Bus Hire',
        heading: 'Amruta Travels: Travel Agents in Pune for Full Bus Hire',
        headingDescription: 'Amruta Travels is one of the leading Travel Agents in Pune for Full Bus Hire, offering reliable and affordable bus rental services for all types of group travel. Whether you’re organizing a school trip, corporate tour, wedding transportation, religious yatra, or picnic, our fleet of fully maintained buses ensures a safe, comfortable, and hassle-free experience.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located around 120 km from Pune, Mahabaleshwar is a scenic hill station famous for its strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Wilson Point. It's an ideal spot for nature lovers and weekend getaways."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range are popular for their green valleys, monsoon waterfalls, and attractions like Bhushi Dam and Tiger’s Leap. Great for a quick escape from city life."
  },
  {
    "title": "Shirdi",
    "description": "About 190 km from Pune, Shirdi is a major pilgrimage town dedicated to Sai Baba. The Sai Baba Temple attracts millions of devotees annually. The spiritual atmosphere makes it perfect for religious tourism."
  },
  {
    "title": "Goa",
    "description": "Located nearly 450 km from Pune, Goa is the ultimate beach holiday destination. From vibrant nightlife and water sports to heritage forts and churches, Goa offers something for every traveler."
  },
  {
    "title": "Nashik",
    "description": "Around 210 km from Pune, Nashik is known for its religious significance and as India’s wine capital. Key attractions include the Kalaram Temple, Sula Vineyards, and Trimbakeshwar Temple."
  },
  {
    "title": "Alibaug",
    "description": "Situated 140 km away, Alibaug is a coastal town with serene beaches like Nagaon and historical forts such as Kolaba Fort. It’s a popular choice for beach lovers and family picnics."
  },
  {
    "title": "Kolhapur",
    "description": "Roughly 235 km from Pune, Kolhapur is home to the famous Mahalaxmi Temple and is known for its rich cultural heritage and spicy cuisine. It also offers attractions like Rankala Lake and Panhala Fort."
  },
  {
    "title": "Lavasa",
    "description": "Just 60 km from Pune, Lavasa is a planned city nestled in the Western Ghats, offering lakeside views, water sports, and a peaceful retreat. Perfect for a one-day outing or weekend stay."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "About 120 km from Pune, Satara is a gateway to the Kaas Plateau, a UNESCO-listed biodiversity hotspot. Visit during the monsoon to witness a stunning bloom of wildflowers across the valley."
  },
  {
    "title": "Aurangabad",
    "description": "Situated 235 km from Pune, Aurangabad is known for the Ajanta and Ellora Caves (UNESCO World Heritage Sites), Bibi Ka Maqbara, and Daulatabad Fort. A must-visit for history and architecture enthusiasts."
  }
],

   "services": [
    {
      "name": "Tour Agencies in Pune",
      "description": "Amruta Travels is among the trusted tour agencies in Pune, offering bus rentals, package tours, and travel planning services for local and outstation trips. Whether you're planning a group tour or a family getaway, our experienced team can help you organize a smooth travel experience."
    },
    {
      "name": "Bus Hire Agency in Pune",
      "description": "Looking for a reliable bus hire agency in Pune? Amruta Travels provides a fleet of well-maintained buses ranging from mini to luxury options. Ideal for corporate events, school trips, and wedding transportation, our services ensure safe and comfortable travel."
    },
    {
      "name": "Tourist Agency in Pune",
      "description": "As a full-service tourist agency, Amruta Travels offers curated tours from Pune to destinations like Mahabaleshwar, Shirdi, Goa, and more. We handle everything from transportation to itinerary planning for an enjoyable and hassle-free experience."
    },
    {
      "name": "Travel Agents in Pune",
      "description": "Our expert travel agents in Pune offer personalized assistance for bus bookings, group tours, weekend getaways, and long-distance travel. Amruta Travels ensures you get the best route, pricing, and vehicle for your trip."
    },
    {
      "name": "Pune Tours and Travels Agents",
      "description": "Amruta Travels is recognized among top Pune tours and travels agents. We specialize in group transportation, school field trips, pilgrimage tours, and premium event transport, backed by professional drivers and top-notch service."
    },
    {
      "name": "Bus Hire Agents in Pune",
      "description": "As experienced bus hire agents in Pune, Amruta Travels offers various bus sizes and rental plans for events, office trips, or local sightseeing. Flexible packages and quick booking are available for both AC and non-AC buses."
    },
    {
      "name": "Best Traveller Bus on Rent in Pune",
      "description": "Book the best traveller buses in Pune with Amruta Travels. From 13 to 26-seater options, our Tempo Travellers and Urbania mini buses are ideal for family trips, corporate tours, and outstation travel, ensuring comfort and convenience."
    },
    {
      "name": "Urbania Bus on Rent in Pune for Corporate Outing",
      "description": "Amruta Travels offers Force Urbania buses for corporate outings in Pune. These luxury 13 or 17-seater mini buses come with professional drivers, AC interiors, and are ideal for team-building trips or off-site events."
    },
    {
      "name": "Travel Agents in Pimpri Chinchwad",
      "description": "Serving the PCMC area, Amruta Travels is a go-to travel agent in Pimpri Chinchwad. We offer quick bus rentals, corporate travel solutions, and curated tour packages to major tourist destinations from Pune."
    },
    {
      "name": "Pune Travel Agency Contact Number",
      "description": "To book a bus or tour with Amruta Travels, call us at +91-9158774499. We provide bookings for outstation trips, event buses, Urbania and Tempo Traveller rentals, and more—available across Pune and PCMC."
    },
    {
      "name": "Bus Hire for Events Agency",
      "description": "Amruta Travels offers event-focused bus rental services in Pune. Whether it’s a corporate gathering, cultural event, or wedding, our buses ensure group travel is coordinated, punctual, and comfortable."
    },
    {
      "name": "Bus Hire for Corporate Events & Tours",
      "description": "For corporate events and business tours, Amruta Travels provides AC buses, Urbania mini buses, and Tempo Travellers. Our service ensures timely transport for employees or guests with options for both short and long trips."
    },
    {
      "name": "Bus Booking for Corporate Events",
      "description": "Plan your next company event with Amruta Travels. Our bus booking services cater to seminars, team off-sites, and conferences in and around Pune. Choose from our luxury and executive-class bus fleet."
    },
    {
      "name": "Bus on Hire on Pune to Mahabaleshwar Package Tour",
      "description": "Enjoy a scenic Pune to Mahabaleshwar trip with our special package tours. Amruta Travels offers well-maintained buses with experienced drivers, perfect for weekend getaways, picnics, and family holidays."
    },
    {
      "name": "Tour Operators in Pune",
      "description": "Amruta Travels acts as a full-service tour operator in Pune, organizing trips to Shirdi, Nashik, Goa, and more. We manage transportation, schedule planning, and provide end-to-end travel solutions."
    },
    {
      "name": "Best Tours and Travel Company in PCMC",
      "description": "Based in Pimpri Chinchwad, Amruta Travels is known as one of the best travel companies in PCMC. We specialize in school, corporate, and event travel, offering professional service and affordable rates."
    },
    {
      "name": "Best Tours and Travel Company in Pune",
      "description": "With over a decade of experience, Amruta Travels is considered among Pune's best tours and travel companies. We offer reliable, clean buses with courteous drivers and customizable travel packages."
    }
  ],
  "tableData": [
    ["Tour Agencies in Pune", "Bus Hire Agency in Pune"],
    ["Tourist Agency in Pune", "Travel Agents in Pune"],
    ["Pune Tours and Travels Agents", "Bus Hire Agents in Pune"],
    ["Best Traveller Bus on Rent in Pune", "Urbania Bus on Rent in Pune for Corporate Outing"],
    ["Travel Agents in Pimpri Chinchwad", "Pune Travel Agency Contact Number"],
    ["Bus Hire for Events Agency", "Bus Hire for Corporate Events & Tours"],
    ["Bus Booking for Corporate Events", "Bus on Hire on Pune to Mahabaleshwar Package Tour"],
    ["Tour Operators in Pune", "Best Tours and Travel Company in PCMC"],
    ["Best Tours and Travel Company in Pune", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Trusted Travel Agents in Pune for Full Bus Hire",
    "WhyChoosedescription": "Amruta Travels is a leading travel agency in Pune offering full bus hire services for all types of group travel. Whether it's a corporate event, wedding, school trip, or outstation tour, we provide well-maintained buses with professional drivers to ensure a safe and comfortable journey."
  },
  {
    "WhyChooseheading": "Wide Range of Buses for Every Travel Need",
    "WhyChoosedescription": "We offer a wide selection of buses for full hire, including AC and non-AC options, mini buses, 17-seaters, 35-seaters, and luxury coaches. Our fleet is suitable for various occasions—from local city travel to long-distance tours—ensuring your group travels in comfort."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Bus Hire Packages",
    "WhyChoosedescription": "Our bus hire services come with competitive and transparent pricing. All charges, including fuel, tolls, driver fees, and taxes, are included in the quote with no hidden costs. This makes budgeting easier and gives you peace of mind while planning your group trip."
  },
  {
    "WhyChooseheading": "Experienced Travel Agents with Expert Route Planning",
    "WhyChoosedescription": "With years of experience as travel agents in Pune, we help you plan the most efficient and enjoyable route for your trip. Whether it’s a one-day excursion or a multi-day outstation journey, our team ensures everything is arranged smoothly for a hassle-free experience."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Our full hire buses are regularly cleaned, serviced, and maintained to the highest standards. They feature comfortable seating, air conditioning, entertainment systems, and spacious interiors, making every journey pleasant and relaxing for your group."
  },
  {
    "WhyChooseheading": "Professional Drivers and On-Time Service",
    "WhyChoosedescription": "Our drivers are experienced, punctual, and courteous. They are familiar with local and outstation routes, ensuring your group reaches the destination safely and on time. We prioritize passenger safety and customer satisfaction at every step of the journey."
  },
  {
    "WhyChooseheading": "Easy Booking and Flexible Rental Options",
    "WhyChoosedescription": "Booking a full bus with Amruta Travels is quick and simple through our online portal or by phone. We offer flexible rental durations—from hourly to multi-day bookings—to suit your event or travel plan perfectly."
  },
  {
    "WhyChooseheading": "24/7 Support and Dedicated Customer Assistance",
    "WhyChoosedescription": "Our team is available 24/7 to assist with your full bus hire booking, answer queries, and make any last-minute changes. With dedicated support, we ensure your travel experience is smooth from the moment you book until you reach your destination."
  }
]























    }

const faqData = [
  {
    question: 'Can I hire a full bus through Amruta Travels in Pune?',
    answer: 'Yes, Amruta Travels is a trusted travel agency in Pune offering full bus hire services. Whether you need transportation for a wedding, corporate outing, school trip, or religious tour, we have buses of all sizes available.',
  },
  {
    question: 'What types of buses can I hire fully from Amruta Travels?',
    answer: 'We provide a wide range of buses including 32-seater, 35-seater, 40-seater, and 50-seater options. Our fleet includes AC, Non-AC, and luxury buses to suit different travel needs and budgets.',
  },
  {
    question: 'Do full bus hire packages include a driver?',
    answer: 'Yes, all full bus hire bookings with Amruta Travels include a professional, experienced driver to ensure your journey is safe and smooth.',
  },
  {
    question: 'Is Amruta Travels a reliable travel agent for full bus bookings in Pune?',
    answer: 'Absolutely. With years of experience, well-maintained vehicles, and excellent customer service, Amruta Travels is one of the most reliable travel agents in Pune for full bus hire.',
  },
  {
    question: 'Can I hire a full bus for both local and outstation travel?',
    answer: 'Yes, our full bus hire service is available for both local city travel within Pune and outstation trips to popular destinations like Mumbai, Shirdi, Mahabaleshwar, Goa, and more.',
  },
  {
    question: 'How much does it cost to fully hire a bus in Pune?',
    answer: 'The cost varies depending on the type of bus, seating capacity, trip duration, and distance. Rates typically start from ₹25–₹40 per km. Contact us with your itinerary for a tailored quote.',
  },
  {
    question: 'Are the buses from Amruta Travels sanitized and well-maintained?',
    answer: 'Yes, all our buses undergo regular maintenance and are sanitized thoroughly before each trip to ensure comfort, safety, and hygiene.',
  },
  {
    question: 'How can I book a full bus with Amruta Travels in Pune?',
    answer: 'You can book a full bus by contacting us via phone or through our website. Share your travel details and we’ll assist you in choosing the right vehicle and confirm your booking promptly.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Manoj Desai',
    role: 'HR Manager, Pune',
    text: 'We booked a full 50-seater bus from Amruta Travels for our company outing. The bus was in excellent condition, and the service was professional from start to finish. Will definitely book again!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Anjali Kulkarni',
    role: 'School Administrator, Pune',
    text: 'We hired a 40-seater bus for a school field trip. Amruta Travels provided a safe, clean, and punctual service. The driver was very cooperative, and the kids had a comfortable journey.',
    rating: 5,
  },
];














































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Travel Agents in Pune for Full Bus Hire",
  "image": "https://bushireinpune.com/assets/images/full-bus-hire-agency.jpg", // Update with actual image URL
  "description": "Book a full bus hire through trusted travel agents in Pune for corporate events, tours, and family trips. Offering a range of vehicles including Urbania buses, 17-seater, and 50-seater options.",
  "provider": {
    "@type": "Organization",
    "name": "Amruta Travels",
    "url": "https://bushireinpune.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "580"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000", // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/travel-agents-in-pune-for-full-bus-hire"
  }
};






    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Travel Agents in Pune for Full Bus Hire | Corporate & Tour Bus Rental</title>
  <meta 
    name="description" 
    content="Find trusted travel agents in Pune for full bus hire. Book buses for corporate events, group tours, family trips, and more. A wide range of buses including Urbania and 17-seater options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/79.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Travelsagentsinpuneforfullbushire;